const colors = {
  "color-primary-100": "#D4FCE1",
  "color-primary-200": "#AAFACB",
  "color-primary-300": "#7DF2B9",
  "color-primary-400": "#5BE6B0",
  "color-primary-500": "#2AD6A4",
  "color-primary-600": "#1EB89A",
  "color-primary-700": "#159A8D",
  "color-primary-800": "#0D7B7C",
  "color-primary-900": "#085D66",
  "color-primary-transparent-100": "rgba(42, 214, 164, 0.08)",
  "color-primary-transparent-200": "rgba(42, 214, 164, 0.16)",
  "color-primary-transparent-300": "rgba(42, 214, 164, 0.24)",
  "color-primary-transparent-400": "rgba(42, 214, 164, 0.32)",
  "color-primary-transparent-500": "rgba(42, 214, 164, 0.4)",
  "color-primary-transparent-600": "rgba(42, 214, 164, 0.48)",
  "color-primary-transparent-700": "rgba(42, 214, 164, 0.3)",
  "color-success-100": "#F2E3FE",
  "color-success-200": "#E4C7FE",
  "color-success-300": "#D2ABFD",
  "color-success-400": "#C295FB",
  "color-success-500": "#a973fa",
  "color-success-600": "#8354D7",
  "color-success-700": "#6039B3",
  "color-success-800": "#422490",
  "color-success-900": "#2D1677",
  "color-success-transparent-100": "rgba(169, 115, 250, 0.08)",
  "color-success-transparent-200": "rgba(169, 115, 250, 0.16)",
  "color-success-transparent-300": "rgba(169, 115, 250, 0.24)",
  "color-success-transparent-400": "rgba(169, 115, 250, 0.32)",
  "color-success-transparent-500": "rgba(169, 115, 250, 0.4)",
  "color-success-transparent-600": "rgba(169, 115, 250, 0.48)",
  "color-success-transparent-700": "rgba(169, 115, 250, 0.3)",
  "color-info-100": "#D6F6FE",
  "color-info-200": "#ADE8FE",
  "color-info-300": "#84D6FE",
  "color-info-400": "#65C3FD",
  "color-info-500": "#33a4fc",
  "color-info-600": "#2580D8",
  "color-info-700": "#195FB5",
  "color-info-800": "#104392",
  "color-info-900": "#092F78",
  "color-info-transparent-100": "rgba(51, 164, 252, 0.08)",
  "color-info-transparent-200": "rgba(51, 164, 252, 0.16)",
  "color-info-transparent-300": "rgba(51, 164, 252, 0.24)",
  "color-info-transparent-400": "rgba(51, 164, 252, 0.32)",
  "color-info-transparent-500": "rgba(51, 164, 252, 0.4)",
  "color-info-transparent-600": "rgba(51, 164, 252, 0.48)",
  "color-info-transparent-700": "rgba(51, 164, 252, 0.3)",
  "color-warning-100": "#FEF9CF",
  "color-warning-200": "#FEF29F",
  "color-warning-300": "#FEE96F",
  "color-warning-400": "#FDE04C",
  "color-warning-500": "#FCD111",
  "color-warning-600": "#D8AF0C",
  "color-warning-700": "#B58F08",
  "color-warning-800": "#927005",
  "color-warning-900": "#785A03",
  "color-warning-transparent-100": "rgba(252, 209, 17, 0.08)",
  "color-warning-transparent-200": "rgba(252, 209, 17, 0.16)",
  "color-warning-transparent-300": "rgba(252, 209, 17, 0.24)",
  "color-warning-transparent-400": "rgba(252, 209, 17, 0.32)",
  "color-warning-transparent-500": "rgba(252, 209, 17, 0.4)",
  "color-warning-transparent-600": "rgba(252, 209, 17, 0.48)",
  "color-warning-transparent-700": "rgba(252, 209, 17, 0.3)",
  "color-danger-100": "#FFEAD9",
  "color-danger-200": "#FFCFB3",
  "color-danger-300": "#FFAE8D",
  "color-danger-400": "#FF8F71",
  "color-danger-500": "#FF5B42",
  "color-danger-600": "#DB3930",
  "color-danger-700": "#B72125",
  "color-danger-800": "#931522",
  "color-danger-900": "#7A0C20",
  "color-danger-transparent-100": "rgba(255, 91, 66, 0.08)",
  "color-danger-transparent-200": "rgba(255, 91, 66, 0.16)",
  "color-danger-transparent-300": "rgba(255, 91, 66, 0.24)",
  "color-danger-transparent-400": "rgba(255, 91, 66, 0.32)",
  "color-danger-transparent-500": "rgba(255, 91, 66, 0.4)",
  "color-danger-transparent-600": "rgba(255, 91, 66, 0.48)",
  "color-danger-transparent-700": "rgba(255, 91, 66, 0.3)",
  'color-gray-100': '#F4F4F4',
  'color-gray-200': '#EAEAEA',
  'color-gray-300': '#C1C1C1',
  'color-gray-400': '#848484',
  'color-gray-500': '#333333',
  'color-gray-600': '#2B2525',
  'color-gray-700': '#24191B',
  'color-gray-800': '#1D1013',
  'color-gray-900': '#18090E',
};

export {colors};

